import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { VoiceEngineResponse } from './types';
import { getVoiceEngines, updateVoiceEngine, updateBusinessVoiceEngines } from './api';
import { queryClient } from '@/providers/AllProviders';

export function useGetVoiceEngines(
  params?: Record<string, any>,
  options?: UseQueryOptions<VoiceEngineResponse, Error>
) {
  return useQuery<VoiceEngineResponse>({
    queryKey: ['voice_engines', params],
    queryFn: () => getVoiceEngines(params),
    ...options
  });
}

export function useUpdateVoiceEngine() {
  return useMutation({
    mutationFn: (id: number) => updateVoiceEngine(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['voice_engines'],
        refetchType: 'active'
      });
      queryClient.invalidateQueries({
        queryKey: ['businesses'],
        refetchType: 'active'
      });
    }
  });
}

export function useUpdateBusinessVoiceEngines() {
  return useMutation({
    mutationFn: ({ availableVoiceEngineId, businessIds }: { availableVoiceEngineId: number; businessIds: number[] }) =>
      updateBusinessVoiceEngines(availableVoiceEngineId, businessIds),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['voice_engines']
      });
      queryClient.refetchQueries({
        queryKey: ['businessProfile']
      });
    }
  });
}
